import { getFieldErrors, isApiError, readApiError } from '@/services/api';

type ContactField = 'name' | 'relationshipOther';

const WIRE_TO_FORM_FIELD: Record<string, ContactField> = {
    name: 'name',
    // The six fixed options are short and safe, so a server-side relationship
    // error can only have come from the free text typed under 'Other'.
    relationship: 'relationshipOther',
};

const FALLBACK_MESSAGE = 'Failed to save the authorised contact. Please try again.';

export interface ContactSubmitError {
    fieldErrors: { field: ContactField; message: string }[];
    message: string | null;
}

export function mapContactSubmitError(error: unknown): ContactSubmitError {
    const wireErrors = getFieldErrors(error);
    const fieldErrors = Object.entries(wireErrors).flatMap(([wireField, messages]) => {
        const field = WIRE_TO_FORM_FIELD[wireField];
        return field && messages[0] ? [{ field, message: messages[0] }] : [];
    });
    const hasUnmappedErrors = Object.keys(wireErrors).some((wireField) => !WIRE_TO_FORM_FIELD[wireField]);

    if (fieldErrors.length > 0 && !hasUnmappedErrors) {
        return { fieldErrors, message: null };
    }

    const message = isApiError(error) && error.data ? readApiError(error.data).message : FALLBACK_MESSAGE;
    return { fieldErrors, message };
}
